import { createContext, useContext, useEffect, useState, useMemo } from "react";
import { api } from "./api";
import { IMAGE_SLOTS } from "./imageSlots";

const ImagesContext = createContext({
  images: {},
  getImg: () => "",
  reload: () => {},
  loading: true,
});

export function ImagesProvider({ children }) {
  const [images, setImages] = useState({});
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const r = await api.get("/images");
      setImages(r.data || {});
    } catch (e) {
      // Silent — fallback to defaults
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const defaults = useMemo(() => {
    const map = {};
    IMAGE_SLOTS.forEach((s) => { map[s.slot] = s.default; });
    return map;
  }, []);

  const getImg = (slot, fallback = "") => {
    return images[slot]?.url || defaults[slot] || fallback;
  };

  return (
    <ImagesContext.Provider value={{ images, getImg, reload: load, loading }}>
      {children}
    </ImagesContext.Provider>
  );
}

export function useImages() {
  return useContext(ImagesContext);
}
